import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSparkleHightlight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sparkle-hightlight, special, ai, magic"><path d="M3 3L5.5 5.5M21 3L18.5 5.5M3 21L5.5 18.5M21 21L18.5 18.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.569 3.75H11.431L9.1125 9.1125L3.75 11.431V12.569L9.1125 14.8875L11.431 20.25H12.569L14.8875 14.8875L20.25 12.569V11.431L14.8875 9.1125L12.569 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconSparkleHightlight;
